export default {
    // Extra assignees of a ticket (main assignee stays task.userId)
    GET: (taskId) => `/taskAssignee/${taskId}`,
    SET: (taskId) => `/taskAssignee/${taskId}`,
};
